import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";
import StreetCellContent from "../components/StreetCellContent";

function street({ width, onResize }: Column.Options) {
	return base(ColumnId.Street, (item) => <StreetCellContent item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default street;
